import { render } from "./Header.vue?vue&type=template&id=24d3f456"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=24d3f456&lang=css"

import exportComponent from "/codebuild/output/src231289078/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sgre/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24d3f456"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24d3f456', __exports__)) {
    console.log('reload')
    api.reload('24d3f456', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=24d3f456", () => {
    console.log('re-render')
    api.rerender('24d3f456', render)
  })

}


export default __exports__